import one from '../assets/svg/projects/Gemini_Generated_Image_fbnft2fbnft2fbnf.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'

import six from '../assets/svg/projects/six.svg'



export const projectsData = [
    {
        id: 1,
        projectName: 'Nyayam - Case Data Management System',
        projectDesc: 'Better case management: Created a system to share case data and improve communication between government pleaders (GPs), making case handling easier',
        tags: ['React Js', 'Springboot', 'PostgreSQL'],
        // code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        // demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: one
    },
    {
        id: 2,
        projectName: 'Development for Government Lottery System',
        projectDesc: 'Fair plot allocation: Developed a backend system for a lottery-based plot allocation project, implementing a random beneficiary selection algorithm to ensure fair and transparent distribution of plots.',
        tags: ['Springboot', 'React Js','PostgreSQL'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: two
    },
   {
    id: 3,
    projectName: 'Job Portal',
    projectDesc: 'A role-based job portal developed using Spring Boot, React.js, and PostgreSQL. The platform includes separate dashboards for job seekers and recruiters, allowing recruiters to post openings and job seekers to apply efficiently.',
    tags: ['Spring Boot', 'React.js', 'PostgreSQL'],
    code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    image: three
},
{
    id: 4,
    projectName: 'Building & Other Construction Workers Welfare Board (BOCW)',
    projectDesc: 'A welfare management system for construction workers with online registration, verification, ID generation, and payment gateway integration.',
    tags: ['Spring Boot', 'React.js', 'PostgreSQL'],
    code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    image: four
},
{
    id: 6,
    projectName: 'Labour Department System',
    projectDesc: 'A digital platform for labor welfare operations including registration, verification, approval, and automated report generation.',
    tags: ['Spring Boot', 'React.js', 'PostgreSQL'],
    code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    image: six
}

// {
//     id: 5,
//     projectName: 'E-Commerce App',
//     projectDesc: 'An online sweet shop web application allowing users to browse, order. The platform supports cart management.',
//     tags: ['React Native', 'Firebase'],
//     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
//     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
//     image: five
// },
// {
//     id: 6,
//     projectName: 'Labour Department System',
//     projectDesc: 'A digital system built for government labor department workflows. It allows beneficiaries to register, submit documents, and track application status. Mandal and district-level officers manage verifications, approvals, and beneficiary report generation, ensuring transparency and efficiency.',
//     tags: ['Spring Boot', 'React.js', 'PostgreSQL'],
//     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
//     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
//     image: six
// }

    
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/